import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { FC, memo, ReactNode } from 'react';

import { useSortableItem } from '../../hooks/useSortableItem';

export interface SortableItemProps {
  sortId: number | string;
  disabled?: boolean;
  children:
    | ReactNode
    | ((
        listeners: SyntheticListenerMap | undefined,
        isDragging?: boolean
      ) => ReactNode);
}

export const SortableItem: FC<SortableItemProps> = memo<SortableItemProps>(
  ({ children, sortId, disabled }) => {
    const { setNodeRef, attributes, listeners, style, isDragging } =
      useSortableItem({
        sortId,
        isDraggingOpacity: 0.8,
        disabled,
      });
    return (
      <div ref={setNodeRef} style={style} {...attributes}>
        {typeof children === 'function'
          ? children(listeners, isDragging)
          : children}
      </div>
    );
  }
);
